import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { StoreNotLoading } from '../core/states/store.actions';

@Component({
  selector: 'payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: [ './payment-failed.component.scss' ]
})

export class PaymentFailedComponent implements OnInit {

  constructor(
    private store:Store
  ) { }

  ngOnInit() {
    this.store.dispatch(new StoreNotLoading())
  }
}
